import React from "react";
import CommonPopup from "../../../common-popup/CommonPopup";
import {
    formatPrice,
    formatePriceFn,
} from "../../../../helper/commonFunction";

const FlightPriceChangePopup = ({
    flightPriceChangeInfo,
    agentActiveCurrency,
    displayPrice,
    dismissFlightPriceChangePopupFn,
    backtoSearchButtonFn,
}) => {
    if (!flightPriceChangeInfo?.show) return null;

    const {
        oldPrice,
        newPrice,
        diff,
        direction,
    } = flightPriceChangeInfo;

    const isPriceDown = direction === "down";
    const differenceColor = isPriceDown ? "#1f8f4a" : "#dc2626";
    const differenceSign = isPriceDown ? "-" : "+";

    const formatDisplayPrice = (price) =>
        formatePriceFn(
            agentActiveCurrency,
            formatPrice(price, true, true),
            displayPrice
        );

    const handleBackToSearch = () => {
        dismissFlightPriceChangePopupFn();
        backtoSearchButtonFn();
    };

    return (
        <CommonPopup
            show={flightPriceChangeInfo.show}
            setShow={dismissFlightPriceChangePopupFn}
            title="Real-Time Fare Update"
            modalClass="hw-modal--mediumSmall"
        >
            <div>
                <div className="h6 text-center">
                    Airline fares are updated dynamically. Your selected flight price has changed during checkout.
                </div>

                <div className="hw-table--responsive mt-3">
                    <table className="hw-table--border lr-borderNull xl-big hw-table--baggage">
                        <thead>
                            <tr>
                                <th>Your Price</th>
                                <th>Updated Price</th>
                                <th>Difference</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{formatDisplayPrice(oldPrice)}</td>
                                <td>{formatDisplayPrice(newPrice)}</td>
                                <td
                                    style={{
                                        color: differenceColor,
                                        fontWeight: 700,
                                    }}
                                >
                                    {differenceSign} {formatDisplayPrice(diff)}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="d-flex mt-4 hw-gapy16">
                    <button
                        onClick={dismissFlightPriceChangePopupFn}
                        className="hw-btn hw-btn--primary w-100"
                    >
                        Continue Booking
                    </button>

                    <button
                        onClick={handleBackToSearch}
                        className="hw-btn hw-btn--secondary w-100"
                    >
                        Back to Search
                    </button>
                </div>
            </div>
        </CommonPopup>
    );
};

export default React.memo(FlightPriceChangePopup);